"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Link_1 = __importDefault(require("@mui/material/Link"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
const EpiAppSwitchMenuItem = ({ logo, name, close, url, }) => (react_1.default.createElement(MenuItem_1.default, { onClick: close, "data-testid": name },
    react_1.default.createElement(Link_1.default, { href: url, rel: "noopener noreferrer" },
        react_1.default.createElement("img", { src: logo, alt: name }))));
exports.default = EpiAppSwitchMenuItem;
